/**
 * Collection Load More
 * Fetches the next page and appends products to the current grid.
 */

class CollectionLoadMore {
  constructor() {
    this.init();
  }

  init() {
    // Use event delegation so the listener survives filter/facet re-renders
    // that replace #ProductGridContainer's innerHTML with fresh markup.
    if (CollectionLoadMore._delegated) return;
    CollectionLoadMore._delegated = true;
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.load-more-btn');
      if (btn) this.handleClick(e, btn);
    });
  }

  async handleClick(e, btn) {
    const nextUrl = btn.getAttribute('data-next-url');
    if (!nextUrl || btn.disabled) return;

    // Show loading state
    btn.disabled = true;
    btn.querySelector('.load-more-btn__text').hidden = true;
    btn.querySelector('.load-more-btn__spinner').hidden = false;

    try {
      const response = await fetch(nextUrl);
      if (!response.ok) throw new Error('Network error');

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Find the product grid in the fetched page
      const newGrid = doc.getElementById('product-grid');
      const currentGrid = document.getElementById('product-grid');

      if (newGrid && currentGrid) {
        // Append new items to current grid
        const newItems = newGrid.querySelectorAll('.grid__item');
        newItems.forEach((item) => {
          currentGrid.appendChild(item);
        });
      }

      // Check if there's a next page button in the fetched page
      const newLoadMoreBtn = doc.querySelector('.load-more-btn');
      const newNextUrl = newLoadMoreBtn ? newLoadMoreBtn.getAttribute('data-next-url') : null;

      if (newNextUrl) {
        // Update button with new next URL
        btn.setAttribute('data-next-url', newNextUrl);
        btn.disabled = false;
        btn.querySelector('.load-more-btn__text').hidden = false;
        btn.querySelector('.load-more-btn__spinner').hidden = true;
      } else {
        // No more pages — hide the button container
        const container = btn.closest('.load-more-container');
        if (container) container.hidden = true;
      }
    } catch (err) {
      console.error('Load more failed:', err);
      // Restore button on error
      btn.disabled = false;
      btn.querySelector('.load-more-btn__text').hidden = false;
      btn.querySelector('.load-more-btn__spinner').hidden = true;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CollectionLoadMore();
});

// Re-init on section reload in theme editor
document.addEventListener('shopify:section:load', () => {
  new CollectionLoadMore();
});
